import * as actionTypes from "./actionTypes";
import { fetchGroupingLevels } from "@ls/grouping-service";
import { fetchEntityAttributes } from "@ls/entity-service";

export const AS_OF_DATE_SET = "Selections/AS_OF_DATE";
export const setAsOfDate = (asOfDate) => ({ type: AS_OF_DATE_SET, asOfDate });

export const SET_MODE = "selection/SET_MODE";
export const setMode = (mode) => ({
  type: SET_MODE,
  mode,
});

export const SET_SYMBOLIC_DATE = "selection/SET_SYMBOLIC_DATE";
export const setSymbolicDate = (symbolicDate) => ({
  type: SET_SYMBOLIC_DATE,
  symbolicDate,
});

export const SET_SCENARIOS_VALUE = "selection/SET_SCENARIOS_VALUE";
export const setScenariosValue = (value) => ({
  type: SET_SCENARIOS_VALUE,
  value,
});

export const SET_SIDE_BY_SIDE = "selection/SET_SIDE_BY_SIDE";
export const setSideBySide = (value) => ({
  type: SET_SIDE_BY_SIDE,
  value,
});

export const SET_BENCHMARK_SCENARIOS_VALUE =
  "selection/SET_BENCHMARK_SCENARIOS_VALUE";
export const setBenchmarkScenariosValue = (value) => ({
  type: SET_BENCHMARK_SCENARIOS_VALUE,
  value,
});

export const SET_DISABLE_BMARK_WORKSPACE =
  "selection/SET_DISABLE_BMARK_WORKSPACE";
export const setIsDisableBenchmarkWorkspace = (value) => ({
  type: SET_DISABLE_BMARK_WORKSPACE,
  value,
});

export const SET_GL_PAM = "selection/SET_GL_PAM";
export const setGlPam = (value) => ({
  type: SET_GL_PAM,
  value,
});

export const GROUP_TYPE_SET = "Selections/GROUP_TYPE_SET";
export const setGroupType = (groupType) => ({
  type: GROUP_TYPE_SET,
  groupType,
});

export const GROUP_SET = "Selections/GROUP_SET";
export const setGroup = (groups) => ({ type: GROUP_SET, groups });

export const DISPLAY_BENCHMARKS_SET = "Selections/DISPLAY_BENCHMARKS_SET";
export const setDisplayBenchmarks = (displayBenchmarks) => ({
  type: DISPLAY_BENCHMARKS_SET,
  displayBenchmarks,
});

export const LOOKTHRU_SET = "Selections/LOOKTHRU_SET";
export const setLookthru = (lookthru) => ({
  type: LOOKTHRU_SET,
  lookthru,
});

export const BENCHMARK_ENTITY_ID_SET = "Selections/BENCHMARK_ENTITY_ID_SET";
export const setBenchmarkEntityId = (entityId) => ({
  type: BENCHMARK_ENTITY_ID_SET,
  entityId,
});

export const SET_ENTITY_IDS = "Selections/SET_ENTITY_IDS";
export const setEntityIds = (value) => ({
  type: SET_ENTITY_IDS,
  value,
});
export const ADD_ENTITY_ID = "Selections/ADD_ENTITY_ID";
export const addEntityId = (entityId) => ({
  type: ADD_ENTITY_ID,
  entityId,
});
export const REMOVE_ENTITY_ID = "Selections/REMOVE_ENTITY_ID";
export const removeEntityId = (entityId) => ({
  type: REMOVE_ENTITY_ID,
  entityId,
});
export const CLEAR_ENTITY_IDS = "Selections/CLEAR_ENTITY_IDS";
export const clearEntityIds = () => ({
  type: CLEAR_ENTITY_IDS,
});

export const MAJOR_MINOR_SET = "Selections/MAJOR_MINOR_SET";
export const setMajorMinor = (majorMinor) => ({
  type: MAJOR_MINOR_SET,
  majorMinor,
});

export const SET_USER_INVEST_PLATFORM_IDS = "scenario/SET_ENTITY_IDS";
export const setUserInvestPlatformIds = (platformIds) => {
  return {
    type: SET_USER_INVEST_PLATFORM_IDS,
    value: platformIds,
  };
};

export const GROUPING_LEVELS_REQUEST = "Selections/GROUPING_LEVELS_REQUEST";
export const GROUPING_LEVELS_RECEIVE = "Selections/GROUPING_LEVELS_RECEIVE";
export const requestGroupingLevels = () => {
  return async (dispatch) => {
    dispatch({ type: GROUPING_LEVELS_REQUEST });
    dispatch({
      type: GROUPING_LEVELS_RECEIVE,
      data: (await fetchGroupingLevels()) ?? [],
    });
  };
};

export const GROUPS_REQUEST = "Selections/GROUPS_REQUEST";
export const GROUPS_RECEIVE = "Selections/GROUPS_RECEIVE";
export const requestGroups = (groupTypeEntity, asOfDate) => {
  return async (dispatch) => {
    dispatch({ type: GROUPS_REQUEST, groupType: groupTypeEntity.value });
    dispatch({
      type: GROUPS_RECEIVE,
      groupType: groupTypeEntity.value,
      data: await groupTypeEntity.fetchGroups({ asOfDate }),
    });
  };
};

export const REQUEST_ENTITIES = "Selections/REQUEST_ENTITIES";
export const RECEIVE_ENTITIES = "Selections/RECEIVE_ENTITIES";
export const requestEntities = (asOfDate) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ENTITIES });

    dispatch({
      type: RECEIVE_ENTITIES,
      data: await fetchEntityAttributes({
        entityDates: asOfDate,
        select:
          "entityId,name,benchmarkId,type,currency,minor,major,longName,acId,code,accountAltName",
        relative: false,
        lookthru: false,
      }),
    });
  };
};

export const commitSelections = () => ({ type: actionTypes.COMMIT_SELECTIONS });
